/*
    Helper method to prefix a website url with "http://" if the url does not start with "http://" or "https://"
*/
export const prefixWebsite = (website: string): string => {
  if (!website.match(/^https?:\/\//)) {
    return `http://${website}`;
  }
  return website;
};
